import * as endpoints from '@App/constants/endpoints';
import interceptor from '../interceptor';
import { get, post } from '../util';

const DOCUMENTS = 'documents';

export const listByPatient = async ({ header, patientId }) => {
    const pathUrl = `${endpoints.API_MEDICALRECORD}/${DOCUMENTS}/patient/${patientId}`;
    const axios = interceptor(header);
    return await get(axios, pathUrl);
};

export const create = async ({ header, params }) => {
    const pathUrl = `${endpoints.API_MEDICALRECORD}/${DOCUMENTS}`;
    const axios = interceptor(header);
    return await post(axios, pathUrl, params);
};
